import { TextField, Autocomplete, IconButton, Stack } from "@mui/material";
import { blue } from "@mui/material/colors";
import { SyntheticEvent, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { AvailableJournal } from "./CommonInterfaces";
import { auth } from "../firebase/firebase";
import { argosApiEntryPoint } from "../GlobalConfig";

interface JournalPickerProps {  
  setSelectedJournals: React.Dispatch<React.SetStateAction<string[] | undefined>>  
}

function JournalPicker({ setSelectedJournals }: JournalPickerProps) {

  const [inputValue, setInputValue] = useState('');
  const [validOptionSelected, setValidOptionSelected] = useState(false)
  const [possibleValues, setPossibleValues] = useState<AvailableJournal[]>()

  async function updateInput(e: SyntheticEvent, data: string) {
    setInputValue(data)
    setValidOptionSelected(false)
    if (data && data.length > 3) {

      let authToken = await auth.currentUser?.getIdToken(true)

      fetch(argosApiEntryPoint + '/journal?filter=name:' + encodeURIComponent(data), {
        method: 'GET',
        headers: {
          'content-type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + authToken
        }
      })
        .then((response) => response.json())
        .then((data) => {
          setPossibleValues(data);
        })

    } else {
      setValidOptionSelected(false)
    }
  }

  async function journalSelected(e: SyntheticEvent, value: (string | AvailableJournal)[]) {
    if (value != null) {
      setValidOptionSelected(true)
      let journalIds: string[] = value.map(value => {
        if (typeof value === 'string') {
          return value
        } else {
          return value.journalId
        }
      }
      )
      setSelectedJournals(journalIds)
    }
  }


  function getAvailableJournals(): AvailableJournal[] {
    return possibleValues ?? []
  }

  return (
    <Autocomplete
      multiple
      inputValue={inputValue}
      onInputChange={(e, data) => updateInput(e, data)}
      onChange={(e, value) => journalSelected(e, value)}
      freeSolo
      selectOnFocus
      id="journal-picker-autocomplete"
      options={getAvailableJournals()}
      getOptionLabel={(option) => {
        if (typeof option === "string") {
          return option
        } else {
          return option.journalName
        }
      }
      }
      renderInput={(params) => (
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mt: 4 }}>
          <TextField {...params} label="Journal name" variant="outlined"
            helperText="Start writing the journal name and we will show matching journals after 4 characters" />
          <IconButton type="submit" aria-label="search" sx={{ ml: 2 }}>
            <SearchIcon sx={{ color: blue, fontSize: 40 }} />
          </IconButton>
        </Stack>
      )}
      open={inputValue.length > 3 && !validOptionSelected}
    />
  )
}

export default JournalPicker;